// eslint-disable-next-line complexity
function getComponentName(Component, /* istanbul ignore next */ {defaultComponentName = 'Component'} = {}) {
    const componentName = (
        Component && (
            Component.displayName ||
            Component.name
        ) ||
        /* istanbul ignore next */
        Component.type && (
            Component.type.displayName ||
            Component.type.name
        ) ||
        /* istanbul ignore next */
        defaultComponentName
    );

    return `${componentName}`;
}

function getHigherOrderComponentName(WrapperComponent, WrappedComponent, /* istanbul ignore next */ {defaultWrapperComponentName = 'WrapperComponent', defaultWrappedComponentName = 'WrappedComponent'} = {}) {
    const wrapperComponentName = getComponentName(WrapperComponent, {defaultComponentName: defaultWrapperComponentName});
    const wrappedComponentName = getComponentName(WrappedComponent, {defaultComponentName: defaultWrappedComponentName});

    return `${wrapperComponentName}(${wrappedComponentName})`;
}

export {
    getComponentName,
    getHigherOrderComponentName
};
